/**
 * in this module there are:
 *   - the geolocation function
 *   - the search function and the creation of the result list
 */
import {fromLonLat} from 'ol/proj'
import functions from './functions'
/**
 *
 *  to work need some parameter
 * view = the map view
 * fixed = the fixed settings to check the bounds property
 *  - we check this property to check the boundaries for the geolocation
 * overlay = the overlay to hide the popup
 */
 var pageconfig = JSON.parse($('#pageconfig').val())
 var popupconfig = JSON.parse($('#popupconfig').val())

/**
 * search strings come from sharedText.popup.search_popup
 * a tenant that overrides the popup group in its clientText replaces the whole array,
 * so fall back to the english defaults for any missing string
 */

const searchText = $.extend({
  resultslabel: 'Search results',
  resultcount: ':n results found',
  notfound: 'Address not found.',
  refine: 'Please refine your search or select from the list below. Search has returned the first 100 addresses.',
  mapmoved: 'Map moved to :address'
}, popupconfig.search_popup)

let lang = $('#dropdownLangButton').attr('data-code')
if (lang === '' || lang === null || typeof lang === 'undefined') {lang = 'en'}

/**
 * write a message to the #search_status live region so screen readers announce it
 * the region is cleared first so the same message repeated is still announced
 * any pending message is cancelled so an older one can't overwrite a newer one
 */

let announceTimer

const announce = (msg) => {
  clearTimeout(announceTimer)
  $('#search_status').text('')
  announceTimer = setTimeout(() => $('#search_status').text(msg), 100)
}

/**
 * the result list is a single tab stop (roving tabindex):
 *  - only one result button has tabindex 0, the rest have -1
 *  - while in the list the tab stop follows focus, so tab leaves the list in one press
 *  - when focus leaves the list the tab stop goes back to the picked result, or the first one
 */

const setTabStop = (button) => {
  $('#search_results .findlist-btn').attr('tabindex', '-1')
  button.attr('tabindex', '0')
}

const resetTabStop = () => {
  const buttons = $('#search_results .findlist-btn')
  const current = buttons.filter('[aria-current="true"]')
  setTabStop(current.length ? current : buttons.first())
}

const search = (view, overlay) => {
  /**
   * geolocation
   * run the function when you click on the button
   */

  const mapView = view

  /**
   * populate the hide input for the RestFULL API
   */

  if ($('#ukgaz').length !== 0) {
    $('#ukgaz').val(pageconfig.bounds)
    $('#ukgaz').attr('data-lacode',pageconfig.lacode)
  }

  $('#locposbutton').on('click', () => {
    getLocation()
  })

  $('#search_results').attr('aria-label', searchText.resultslabel)

  /**
   * up/down arrows move focus between the result buttons
   * up from the first result goes back to the search input
   */

  $('#search_results').on('keydown', '.findlist-btn', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') {
      return
    }
    e.preventDefault()

    const buttons = $('#search_results .findlist-btn')
    const i = buttons.index(this)

    if (e.key === 'ArrowDown' && i < buttons.length - 1) {
      buttons.eq(i + 1).trigger('focus')
    }
    else if (e.key === 'ArrowUp') {
      (i > 0 ? buttons.eq(i - 1) : $('#find')).trigger('focus')
    }
  })

  /**
   * down arrow from the search input moves into the result list, on the current tab stop
   */

  $('#find').on('keydown', (e) => {
    const tabStop = $('#search_results .findlist-btn[tabindex="0"]')
    if (e.key !== 'ArrowDown' || !$('#searchcont').is(':visible') || !tabStop.length) {
      return
    }
    e.preventDefault()
    tabStop.trigger('focus')
  })

  $('#search_results').on('focusin', '.findlist-btn', function () {
    setTabStop($(this))
  })

  $('#search_results').on('focusout', function (e) {
    if (!this.contains(e.relatedTarget)) {
      resetTabStop()
    }
  })

  /**
   * check if the browser support geolocation
   * display the correct error based on which language is selected
   */

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError)
    }
    else {
      if (window.location.href.indexOf('?lang=cy') > -1) {
        $('.locError').text('Ni chefnogir canfod lleoliad gan y porwr hwn.')
      }
      else {
        $('.locError').text('Geolocation is not supported by this browser.')
      }
      $('#locpopup').modal('show')
    }
  }

  /**
   * if the browser support geolocation
   * move the map accordingly
   * or display an error if outside of the boundaries
   * based on which language is selected
   */

  const showPosition = (position) => {
    // get the extent from fixed.json and create the array
    let getExt = pageconfig.bounds.split(',')
    let ext = [parseInt(getExt[0]), parseInt(getExt[1]), parseInt(getExt[2]), parseInt(getExt[3])]

    /**
     * convert the coordinates from longitude/latitude into the x/y format EPSG:27700
     * store it in an object to use it later in the moveMap function
     */

    let coordToConvert = fromLonLat([position.coords.longitude, position.coords.latitude], 'EPSG:27700')
    let convertedCoord = {
      easting: parseFloat(coordToConvert[0]),
      northing: parseFloat(coordToConvert[1])
    }

    if (convertedCoord.easting >= ext[0] && convertedCoord.easting <= ext[2] && convertedCoord.northing >= ext[1] && convertedCoord.northing <= ext[3]) {
      const zoomTo = mapView.getView().getResolutions().length
      moveMap(mapView, zoomTo, convertedCoord)
    }
    else {
      if (window.location.href.indexOf('?lang=cy') > -1) {
        $('.locError').text('Mae eich lleoliad y tu allan i\'r ardal sydd ar gael.')
      }
      else {
        $('.locError').text('Your position is outside the available area.')
      }
      $('#locpopup').modal('show')
    }
  }

  /**
   * callback to display why the geolocations is unavailable
   * based on which language is selected
   */

  const showError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        if (window.location.href.indexOf('?lang=cy') > -1) {
          $('.locError').text('Gwrthodwyd cais y defnyddiwr i Ganfod lleoliad.')
        }
        else {
          $('.locError').text('User denied the request for Geolocation.')
        }
        $('#locpopup').modal('show')
        break

      case error.POSITION_UNAVAILABLE:
        if (window.location.href.indexOf('?lang=cy') > -1) {
          $('.locError').text('Nid yw\'r wybodaeth am y lleoliad ar gael.')
        }
        else {
          $('.locError').text('Location information is unavailable.')
        }
        $('#locpopup').modal('show')
        break

      case error.TIMEOUT:
        if (window.location.href.indexOf('?lang=cy') > -1) {
          $('.locError').text('Daeth cyfnod y cais i gael lleoliad y defnyddiwr i ben.')
        }
        else {
          $('.locError').text('The request to get user location timed out.')
        }
        $('#locpopup').modal('show')
        break

      case error.UNKNOWN_ERROR:
        if (window.location.href.indexOf('?lang=cy') > -1) {
          $('.locError').text('Digwyddodd gwall anhysbys.')
        }
        else {
          $('.locError').text('An unknown error occurred.')
        }
        $('#locpopup').modal('show')
        break

      default:
        if (window.location.href.indexOf('?lang=cy') > -1) {
          $('.locError').text('lleoliad yn gywir')
        }
        else {
          $('.locError').text('position correct')
        }
    }
  }

  /**
   * search behaviour
   */

  /**
   * when you click on the X in the search input:
   *  - hide the result
   *  - reset the input value
   *  - stop any propagation or default behaviour
   */

  $('#searchClose').on('click', (e) => {
    $('#searchcont').hide()
    $('#find').val('')
    e.stopPropagation()
    e.preventDefault()
  })

  /**
   * when you press the ENTER key in the search input:
   *  - execute the find function emulating a click on the search button
   *  - hide the popup in the map
   */

  $('#find').keypress((e) => {
    if (e.which === 13 && $('#find').val() !== '') {
      $('#findbutton').click()
    }
  })

  /**
   * find function based on the hide $('#ukgaz') input:
   *  - ask for the api gazetteer file
   *  - ask for the RestFULL API
   *  - create the address list
   *  - attach a event listener on each address
   */

  $('#findbutton').click(() => {
    // hide the popup
    overlay.setPosition(undefined)

    // prevent execution of the function if the input is empty
    if ($('#find').val() !== '') {
      /**
       * show the loading bar
       * disable the button to preven multiple instances
       */

      $('.loading').show()
      $('#findbutton').prop('disabled', true)

      /**
       * RestFULL API case
       */

      if ($('#ukgaz').length !== 0) {
        // remove previous results and message from the div
        $('#search_results').empty()
        $('#search_message').empty()

        const findthis = $('#find').val()
        const ext = $('#ukgaz').val()
        const lacodes = $('#ukgaz').attr('data-lacode')
        let type = 'opendata';
        let dataString = `findthis=${findthis}&bbox=${ext}&limit=100`
        if (lacodes !== '' || lacodes !== null || typeof lacodes !== 'undefined') {
            dataString = `findthis=${findthis}&lacode=${lacodes}&limit=100`
        }


        if (pageconfig.gaz) {
            type = 'addressbasesearch';
            dataString = `findaddress=${findthis}&bbox=${ext}&lang=${lang}&limit=100`
            if (lacodes !== '' || lacodes !== null || typeof lacodes !== 'undefined') {
                dataString = `findaddress=${findthis}&lacode=${lacodes}&lang=${lang}&limit=100`
            }
        }

        dataString += `&type=` + type

        // AJAX Code To Submit Form.
        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: '/find-address',
          data: dataString,
          beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'))
          }
        })
          .done((data) => {
            /**
             * create the result list
             */

            apiresults(mapView, data)
          })
          /**
           * show the reason why doesn't work on fail
           */

          .fail((response) => {
            let  error = response.responseJSON.error
            let  textStatus = response.status
            let err = `${textStatus}, ${error}`
            alert(`getAddress Request Failed: ${err}`)
          })
          .always(() => {
            /**
             * hide the loading bar
             * reenable the search button
             */

            $('.loading').hide()
            $('#findbutton').prop('disabled', false)
          })
      }
    }

    /**
     * end $('#findbutton').click(() => {
     * end const search = (view, fixed, overlay) =>
     */
  })
}

/**
 * move the map to the correct location
 * we initialize the function with parameters in orders to be indipendent
 */

const moveMap = (view, zoomlv, coord) => {
  const zoom = view.getView().getResolutions()
  //if (zoomlv > view.getView().getResolutions().length) {
    zoomlv = view.getView().getResolutions().length - 1
  //}

  view.getView().setResolution(zoom[parseInt(zoomlv) - 1])
  view.getView().centerOn([parseFloat(coord.easting), parseFloat(coord.northing)], view.getSize(), [($(window).innerWidth() / 2), ($(window).innerHeight() / 2)])
  view.updateSize()
}

/**
 * select a result:
 *  - center the map on it
 *  - mark it as the current result
 *  - announce the move to screen readers
 *  - hide the menu if is a mobile, returning focus to the menu toggle
 */

const selectResult = (view, place, button) => {
  moveMap(view, place.zoomto, place)

  $('#search_results .findlist-btn').removeAttr('aria-current')
  button.attr('aria-current', 'true')
  setTabStop(button)

  announce(searchText.mapmoved.replace(':address', () => place.full_address))

  if (functions.mobileTabletView()) {
    $('#dropdownToolsMobile').trigger('click').trigger('focus')
  }
}

/**
 * create the api result table
 *  - we pass the data for create the address list
 *  - we pass the map view to pass it in the moveMap function
 */

const apiresults = (view, data) => {
  /**
   * create a list of each returned element
   * each result is a button so it can be reached and selected with the keyboard
   */

  // the api can return addresses as an object keyed by index rather than an array, so convert it to get a length
  const addresses = $.map(data.addresses || {}, (place) => place)

  $.each(addresses, function () {
    const place = this

    const button = $('<button />', {
      type: 'button',
      text: place.full_address
    })
      .addClass('findlist-btn')
      .click(() => selectResult(view, place, button))

    $('<li>')
      .addClass('findlist')
      .append(button)
      .appendTo('#search_results')
  })

  resetTabStop()

  /**
   * display correct message depending on the result
   * focus stays in the search input, the message is announced to screen readers
   */

  /**
   * error from the api
   * display the reason above the list
   */

  if (data.error) {
    $('#search_message').text(data.error.reason)
    announce(data.error.reason)
  }
  /**
   * 0 results
   * display not found above the list
   */
  else if (addresses.length === 0) {
    $('#search_message').text(searchText.notfound)
    announce(searchText.notfound)
  }
  /**
   * 1 result
   * center the map on it
   * show the list with the only result
   */
  else if (addresses.length === 1) {
    selectResult(view, addresses[0], $('#search_results .findlist-btn').first())
  }
  /**
   * 100 results
   * display the 100 limit result alert above the list
   * show the list with the results
   */
  else if (addresses.length === 100) {
    $('#search_message').text(searchText.refine)
    announce(searchText.refine)
  }
  /**
   * > 1 < 100 results
   * show the list with the results
   */
  else {
    announce(searchText.resultcount.replace(':n', addresses.length))
  }

  $('#searchcont').show()
}

/**
 * EXPORT
 */

export default {
  search
}
